export default class MASS_CheckerClass{

    public getDefault_massClass(): string{
        return '\n  "classes": {},';
    }

}